// extracted by mini-css-extract-plugin
module.exports = {"root":"option-group_root__rtytG","options":"option-group_options__2qQQj"};